exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alternate{background-color:#e5e8e8}.gz-legend{color:#767676;padding-left:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/form-footer-bar/form-footer-bar.scss
// module id = 112
// module chunks = 0